<template>
  <div class="checkbox" :class="disabledClass" :style="{ marginLeft: wrapMarginLeft }">
    <div :style="checkboxStyle" class="checkbox-icon" @click="changeCheckbox">
      <span :class="checkIconClass" :style="checkIconStyle"></span>
    </div>
    <span
      v-if="props.label"
      class="label"
      :style="{ paddingLeft: labelMarginLeft || '8px' }"
      @click="changeCheckbox"
    >
      <slot name="default">
        {{ props.label }}
      </slot>
    </span>
  </div>
</template>
<script lang="ts" setup>
import {
  defineProps,
  defineEmits,
  computed,
  watch,
  ref,
  withDefaults,
  inject,
  watchEffect,
} from "vue";
import { CHECK_BOX_SYMBOL_KEY } from "./cy-checkbox-group.vue";
import type { ProvideType } from "./cy-checkbox-group.vue";

const props = withDefaults(
  defineProps<{
    modelValue?: boolean; // 单个使用
    value?: string | number | boolean; // 多个使用
    disabled?: boolean;
    label?: string; // lable 或者label slot
    labelMarginLeft?: string; // 8px
    wrapMarginLeft?: string; // 16px 包容容器外层的margin
    checkboxType?: "rect" | "round" | "face-round"; // 复选框的类型 是方的 还是圆的 还是面性勾选
    fontSize?: string;
    checkColor?: string;
    uncheckColor?: string;
  }>(),
  {
    checkboxType: "rect",
    labelMarginLeft: "8px",
    wrapMarginLeft: "16px",
    fontSize: "14px",
    checkColor: "#000000",
    uncheckColor: "#888888",
  }
);

const emits = defineEmits<{
  (e: "update:model-value", value: any): void;
  (e: "change", value: any): void;
}>();

const injectInfo = inject<ProvideType | null>(CHECK_BOX_SYMBOL_KEY, null);

const curValue = ref(false);
const disabledFromGroup = ref(false);

const disabledClass = computed(() => {
  if (disabledFromGroup.value) return "disabled";
  return props.disabled ? "disabled" : "cur-point";
});
const checkIconClass = computed(() => {
  if (props.checkboxType === "rect") {
    return `iconfont ${
      curValue.value
        ? "icon-gouxuantianman_gouxuanicon check"
        : "uncheck icon-tianman_weigouxuanicon"
    }`;
    
  }
  if (props.checkboxType === "face-round") {
    return `iconfont ${
      curValue.value
        ? "icon-mianxinggouxuan check"
        : "uncheck icon-tianman_weigouxuanicon"
    }`;
  }
  if (props.disabled) {
    return `disabled`;
  }
  return `iconfont ${
    curValue.value
      ? "icon-xianxing_gouxuancion check"
      : "uncheck icon-a-gouxuan_yuanxingicon"
  }`;
});
const checkboxStyle = computed(() => {
  return {
    width: props.fontSize,
    height: props.fontSize,
  };
});
const checkIconStyle = computed(() => {
  return {
    fontSize: props.fontSize,
    color: curValue.value ? props.checkColor : props.uncheckColor,
  };
});

const changeCheckbox = () => {
  if (props.disabled) return;
  const check = !curValue.value;
  curValue.value = check;
  emits("update:model-value", check);
  emits("change", check);
  if (injectInfo) {
    injectInfo.setGroupValue(() => {
      return {
        value: props.value,
        isCheck: curValue.value,
      };
    });
  }
};

watch(
  () => props.modelValue,
  (newValue) => {
    curValue.value = Boolean(newValue);
  },
  { immediate: true }
);
watchEffect(() => {
  if (!injectInfo) return;
  const groupValue = injectInfo?.curValue;
  if (groupValue && groupValue.includes(props.value!)) {
    curValue.value = true;
  } else {
    curValue.value = false;
  }
  const check = curValue.value;
  emits("update:model-value", check);
  emits("change", check);
  const groupDisabled = injectInfo?.getGroupDisabled();
  disabledFromGroup.value = Boolean(groupDisabled);
});
</script>
<style scoped lang="less">
.checkbox {
  display: flex;
  align-items: center;
  line-height: 13px;
  margin-left: 8px;
  flex-shrink: 0;
  // margin-bottom: 8px;
}
.checkbox.disabled {
  .checkbox-icon {
    span {
      background: #eeeeee;
      color: #ccc;
    }
  }
}
.label {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 16px;
}
.cur-point {
  cursor: pointer;
}
.disabled {
  cursor: not-allowed;
  .checkbox-icon {
    color: var(--vt-c-white-soft);
    pointer-events: none;
  }
  .label {
    color: @liner-text-color;
    pointer-events: none;
  }
}
</style>
